export const supportConstants = {
  GET_ALL_SUPPORT_TICKETS: {
    request: "GET_ALL_SUPPORT_TICKETS_REQUEST",
    success: "GET_ALL_SUPPORT_TICKETS_SUCCESS",
    error: "GET_ALL_SUPPORT_TICKETS_FAILURE",
  },
};
